import React, { useState, useEffect } from "react";
import { connect, useDispatch } from "react-redux";

import {
  Input,
  Row,
  Typography,
  Col,
  Card,
  Select,
  Collapse,
  Form,
  Divider,
  Spin,
  DatePicker,
  Button,
} from "antd";
import { PlusOutlined, MinusOutlined } from "@ant-design/icons";
import { useNavigate, Link } from "react-router-dom";
import CustomButton from "../../../../components/custom/CustomButton";
import dayjs from "dayjs";

//PROJECT IMPORTS
import appStatic from "../../../../config/appStatic";
import appLabel from "../../../../config/appLabel";
import cnt from "../../../../services/definedConstant";
import { BOM } from "../../../../services/definedMethod";
import definedApi from "../../../../services/definedApi";
import AffectGlForm from "./AffectGlForm";
// import "./index.css";
import { log } from "@antv/g2plot/lib/utils";
import { showCheckerApprovalModal } from "../../../../components/CheckerModal";

const JournalEntryForm = (props) => {
  //DECLARED VARIABLES
  const { userData } = props;
  const { session } = userData;
  const { Text, Title } = Typography;
  const { TextArea } = Input;

  const navigate = useNavigate();
  const [accountData, setAccountData] = useState([]);
  const [officeData, setOfficeData] = useState([]);
  const [currencyData, setCurrencyData] = useState([]);
  const [paymentTypeData, setpaymentTypeData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    console.log(BOM.HasPermission("READ_PAYMENTTYPE"));

    getOffice();
    getCurrency();
    getPaymentType();
    getGlAccount();
  }, []);

  function onCancel() {
    navigate("/gla0100", { replace: false });
  }

  function getOffice() {
    let body = {
      session,
    };

    BOM.FetchReqAction(body, definedApi.GetOfficeList, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
      } else {
        const objList = res;
        let temp = [];

        console.log(objList);

        objList.forEach((element) => {
          temp.push({
            value: element.id,
            label: element.name,
          });
        });

        setOfficeData(temp);
      }
    });
  }
  function getCurrency() {
    let body = {
      session,
    };

    BOM.FetchReqAction(body, definedApi.CurrencyList, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
      } else {
        const objList = res.selectedCurrencyOptions;
        let temp = [];

        console.log(objList);

        objList.forEach((element) => {
          temp.push({
            value: element.code,
            label: element.displayLabel,
          });
        });

        setCurrencyData(temp);
      }
    });
  }

  function getGlAccount() {
    let body = {
      session,
    };

    BOM.FetchReqAction(body, definedApi.GetSpecificGLList, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
      } else {
        const objList = res;
        let temp = [];

        // objList.forEach((element) => {
        //   temp.push({
        //     value: element.id,
        //     label: element.name,
        //   });
        // });

        temp =
          objList
            ?.filter((element) => element.manualEntriesAllowed)
            .map((element) => ({
              value: element.id,
              label: `${element.glCode} (${element.name})`,
            })) || [];

        setAccountData(temp);
      }
    });
  }
  function getPaymentType() {
    let body = {
      session,
    };

    BOM.FetchReqAction(body, definedApi.PaymentTypeList, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
      } else {
        const objList = res;
        let temp = [];

        objList.forEach((element) => {
          temp.push({
            value: element.id,
            label: element.name,
          });
        });

        setpaymentTypeData(temp);
      }
    });
  }

  // util to validate debit-credit pairs
  const validateOneToOneMatch = (debits, credits) => {
    const debitAmounts = debits
      .map((d) => Number(d.amount))
      .filter((a) => !isNaN(a));
    const creditAmounts = credits
      .map((c) => Number(c.amount))
      .filter((a) => !isNaN(a));

    const totalDebit = debitAmounts.reduce((sum, a) => sum + a, 0);
    const totalCredit = creditAmounts.reduce((sum, a) => sum + a, 0);

    if (totalDebit !== totalCredit) {
      return {
        valid: false,
        message: `Total mismatch: Debits = ${totalDebit}, Credits = ${totalCredit}`,
      };
    }

    // Case 1: Equal counts → must be a permutation (order doesn't matter)
    if (debitAmounts.length === creditAmounts.length) {
      const sortedDebits = [...debitAmounts].sort((a, b) => a - b);
      const sortedCredits = [...creditAmounts].sort((a, b) => a - b);

      for (let i = 0; i < sortedDebits.length; i++) {
        if (sortedDebits[i] !== sortedCredits[i]) {
          return {
            valid: false,
            message:
              "Debits and credits must match as sets when counts are equal.",
          };
        }
      }
      return { valid: true };
    }

    // Case 2: Counts differ → only valid if it's strictly 1-to-many
    if (
      (debitAmounts.length === 1 && creditAmounts.length > 1) ||
      (creditAmounts.length === 1 && debitAmounts.length > 1)
    ) {
      return { valid: true }; // allowed as long as totals already match
    }

    // Case 3: Any other many-to-many mismatch is invalid
    return {
      valid: false,
      message:
        "Invalid entry counts: only equal counts or 1-to-many relationships are allowed.",
    };
  };

  const onSubmit = (formValues) => {
    console.log(formValues);
    const debitEntries = formValues.debits || [];
    const creditEntries = formValues.credits || [];

    const result = validateOneToOneMatch(debitEntries, creditEntries);
    console.log(result);

    if (!result.valid) {
      BOM.AlertMsg(cnt.DANGER, result.message);
      return;
    }

    const originalDate = new Date(formValues.transactionDate);
    const day = originalDate.getDate();
    const month = new Intl.DateTimeFormat("en", { month: "long" }).format(
      originalDate,
    );
    const year = originalDate.getFullYear();
    const formattedDate = `${day} ${month} ${year}`;

    formValues.transactionDate = formattedDate;

    const body = {
      ...formValues,
      locale: "en",
      dateFormat: "dd MMMM yyyy",
      method: "POST",
      session,
    };

    setIsLoading(true);
    BOM.FetchReqAction(
      body,
      definedApi.NewJournalEntries,
      (err, res) => {
        if (err) {
          // BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
          BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
          setIsLoading(false);
        } else {
          BOM.AlertMsg(cnt.SUCCESS, appLabel.newJournalEntryMsg);
          navigate("/view-gla0200", {
            state: {
              transactionId: res.transactionId,
            },
          });
          //STOP LOAD
          setIsLoading(false);
        }
      },
      {
        navigate,
        showCheckerModal: showCheckerApprovalModal,
        onCheckerApproval: (res) => {
          navigate("/gla0200");
          setIsLoading(false);
        },
      },
    );
  };

  const [ghost, setGhost] = useState(null);
  const Items = [
    {
      key: "1",
      label: "Show Payment Details",
      children: (
        <>
          <Row style={{ justifyContent: "spacebetween", marginTop: "15px" }}>
            <Col span={12} style={{ padding: "0px 8px" }}>
              <Form.Item
                name="paymentTypes"
                label={
                  <Text style={{ fontSize: "16px" }}>
                    {appLabel.paymentTypes}
                  </Text>
                }
              >
                <Select
                  placeholder={BOM.handlePlaceholderMsg(appLabel.paymentTypes)}
                  options={paymentTypeData}
                  showSearch
                  allowClear
                />
              </Form.Item>
            </Col>
            <Col span={12} style={{ padding: "0px 8px" }}>
              <Form.Item
                name="account"
                label={
                  <Text style={{ fontSize: "16px" }}>
                    {appLabel.accountNumber}
                  </Text>
                }
              >
                <Input
                  placeholder={BOM.handlePlaceholderMsg(
                    appLabel.accountNumber,
                    appLabel.pleaseEnter,
                  )}
                />
              </Form.Item>
            </Col>
          </Row>
          <Row style={{ justifyContent: "spacebetween", marginTop: "15px" }}>
            <Col span={12} style={{ padding: "0px 8px" }}>
              <Form.Item
                name="cheque"
                label={
                  <Text style={{ fontSize: "16px" }}>
                    {appLabel.chequeNumber}
                  </Text>
                }
              >
                <Input
                  placeholder={BOM.handlePlaceholderMsg(
                    appLabel.chequeNumber,
                    appLabel.pleaseEnter,
                  )}
                />
              </Form.Item>
            </Col>
            <Col span={12} style={{ padding: "0px 8px" }}>
              <Form.Item
                name="routingCode"
                label={
                  <Text style={{ fontSize: "16px" }}>
                    {appLabel.routingCode}
                  </Text>
                }
              >
                <Input
                  placeholder={BOM.handlePlaceholderMsg(
                    appLabel.routingCode,
                    appLabel.pleaseEnter,
                  )}
                />
              </Form.Item>
            </Col>
          </Row>
          <Row style={{ justifyContent: "spacebetween", marginTop: "15px" }}>
            <Col span={12} style={{ padding: "0px 8px" }}>
              <Form.Item
                name="receipt"
                label={
                  <Text style={{ fontSize: "16px" }}>
                    {appLabel.receiptNumber}
                  </Text>
                }
              >
                <Input
                  placeholder={BOM.handlePlaceholderMsg(
                    appLabel.receiptNumber,
                    appLabel.pleaseEnter,
                  )}
                />
              </Form.Item>
            </Col>
            <Col span={12} style={{ padding: "0px 8px" }}>
              <Form.Item
                name="bank"
                label={
                  <Text style={{ fontSize: "16px" }}>{appLabel.bank}</Text>
                }
              >
                <Input
                  placeholder={BOM.handlePlaceholderMsg(
                    appLabel.bank,
                    appLabel.pleaseEnter,
                  )}
                />
              </Form.Item>
            </Col>
          </Row>
        </>
      ),
    },
  ];

  return (
    <Spin spinning={isLoading} size="large">
      <Form
        layout="vertical"
        onFinish={onSubmit}
        initialValues={{ debit: [{}], credit: [{}] }}
      >
        <Card
          style={{
            marginBottom: "3%",
            boxShadow: "0px 0px 30px 5px rgba(0,0,0,0.025)",
          }}
          bordered
        >
          <Row>
            <Divider orientation="left" orientationMargin="0">
              {appLabel.generalInfo}
            </Divider>
            <Col span={12} style={{ padding: "0px 8px" }}>
              <Form.Item
                name="officeId"
                rules={[
                  {
                    required: true,
                    message: "This field is required",
                  },
                ]}
                label={
                  <Text
                    style={{ fontSize: "16px" }}
                    rules={[
                      {
                        required: true,
                        message: BOM.CheckReqFld(appLabel.office),
                      },
                    ]}
                  >
                    {appLabel.office}
                  </Text>
                }
              >
                <Select
                  placeholder={BOM.handlePlaceholderMsg(appLabel.office)}
                  options={officeData}
                  showSearch
                  allowClear
                />
              </Form.Item>
            </Col>
            <Col span={12} style={{ padding: "0px 8px" }}>
              <Form.Item
                name="currencyCode"
                rules={[
                  {
                    required: true,
                    message: "This field is required",
                  },
                ]}
                label={
                  <Text
                    style={{ fontSize: "16px" }}
                    rules={[
                      {
                        required: true,
                        message: BOM.CheckReqFld(appLabel.office),
                      },
                    ]}
                  >
                    {appLabel.currency}
                  </Text>
                }
              >
                <Select
                  placeholder={BOM.handlePlaceholderMsg(appLabel.currency)}
                  options={currencyData}
                  showSearch
                  allowClear
                />
              </Form.Item>
            </Col>
          </Row>

          <Row>
            <Col span={24}>
              <Divider orientation="left" orientationMargin="0">
                {appLabel.affectedGLEntries}
              </Divider>
              <Title
                level={5}
                style={{ paddingTop: 10, paddingBottom: 10, marginTop: 10 }}
              ></Title>
              <div style={{ marginBottom: "25px" }}>
                <AffectGlForm
                  formName={appLabel.debits}
                  glAccountList={accountData}
                  labelParam={appLabel.debit}
                />
              </div>
              <div>
                <div style={{ marginBottom: "25px" }}>
                  <AffectGlForm
                    formName={appLabel.credits}
                    glAccountList={accountData}
                    labelParam={appLabel.credit}
                  />
                </div>
              </div>
            </Col>
          </Row>
          <Divider orientation="left" orientationMargin="0">
            {appLabel.additionalInfo}
          </Divider>

          <Row style={{ marginTop: "15px" }}>
            <Col span={12} style={{ padding: "0px 8px" }}>
              <Form.Item
                name="referenceNumber"
                label={
                  <Text style={{ fontSize: "16px" }}>
                    {appLabel.referenceNumber}
                  </Text>
                }
              >
                <Input
                  placeholder={BOM.handlePlaceholderMsg(
                    appLabel.referenceNumber,
                    appLabel.pleaseEnter,
                  )}
                />
              </Form.Item>
            </Col>
            <Col span={12} style={{ padding: "0px 8px" }}>
              <Form.Item
                name="transactionDate"
                label={
                  <Text style={{ fontSize: "16px" }}>
                    {appLabel.transactionDate}
                  </Text>
                }
                rules={[
                  {
                    required: true,
                    message: BOM.CheckReqFld(appLabel.transactionDate),
                  },
                ]}
              >
                <DatePicker
                  placeholder={BOM.handlePlaceholderMsg(
                    appLabel.transactionDate,
                    appLabel.pleaseEnter,
                  )}
                  style={{ width: "100%", height: 35 }}
                  // locale={dateLocale}
                  // onChange={onChange}
                />
              </Form.Item>
            </Col>
          </Row>
          <Collapse
            ghost={ghost}
            items={Items}
            bordered={false}
            expandIconPosition={"end"}
            style={{ padding: "0px", marginBottom: 15, marginTop: 15 }}
            expandIcon={({ isActive }) => {
              {
                isActive ? setGhost(false) : setGhost(true);
              }
              return (
                <>
                  {isActive ? (
                    <Button
                      height="15%"
                      width="15%"
                      style={{ borderRadius: 10 }}
                      type="text"
                      icon={<MinusOutlined />}
                      className="of-primaryBtnColor"
                    />
                  ) : (
                    <Button
                      height="15%"
                      width="15%"
                      style={{ borderRadius: 10 }}
                      type="text"
                      icon={<PlusOutlined />}
                      className="of-primaryBtnColor"
                    />
                  )}
                </>
              );
            }}
          />

          <Row>
            <Form.Item
              name="comments"
              label={
                <Text style={{ fontSize: "16px" }}>{appLabel.comments}</Text>
              }
              style={{ width: "100%" }}
            >
              <TextArea
                showCount
                maxLength={100}
                placeholder={BOM.handlePlaceholderMsg(
                  appLabel.comments,
                  appLabel.pleaseEnter,
                )}
                style={{
                  height: 120,
                  resize: "none",
                }}
              ></TextArea>
            </Form.Item>
          </Row>
        </Card>
        <Form.Item>
          <Row>
            {BOM.HasPermission("CREATE_JOURNALENTRY") && (
              <CustomButton
                content="Submit"
                style={{
                  width: "10%",
                  marginLeft: "auto",
                  boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                }}
                htmlType="submit"
                backgroundColor="#15CCAE"
                colorText="black"
                hoverBackground="#4FECA0"
              />
            )}
            <CustomButton
              content="Cancel"
              style={{
                width: "10%",
                marginLeft: "1%",
                boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
              }}
              backgroundColor="#fff"
              colorText="black"
              hoverBackground="#F5F5F5"
              onClick={onCancel}
            />
          </Row>
        </Form.Item>
      </Form>
    </Spin>
  );
};

const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
  rightBtn: state.RightSideBtn,
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(JournalEntryForm);
